import { capitalizeIfLower } from '@btime/helpers'
import { isEmpty } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { FlexCol } from '../../../../components/structure/FlexGrid'
import { Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import { useReplies, useServiceOrder } from '../_load/ServiceOrderLoader'
import Accordion from '../../../../components/structure/accordion/Accordion'
import AccordionContent from '../../../../components/structure/accordion/AccordionContent'
import AccordionHeader from '../../../../components/structure/accordion/AccordionHeader'
import DynamicListCounters from '../../../../containers/dynamic/presentationList/DynamicListCounters'
import DynamicPresentationList from '../../../../containers/dynamic/presentationList/DynamicPresentationList'

const RepliesAccordion = () => {
  const { t } = useTranslation('serviceOrders')
  const serviceOrder = useServiceOrder()
  const replies = useReplies()
  if (isEmpty(replies)) return false

  return (
    <FlexCol>
      <Accordion startsOpen lineBorder mediumPadding={false}>
        <AccordionHeader>
          <Grid justify="space-between">
            <Title size="h4" noMargin>
              {capitalizeIfLower(serviceOrder.checklist.name)}
            </Title>
            <DynamicListCounters replies={replies} />
          </Grid>
        </AccordionHeader>
        <AccordionContent>
          <DynamicPresentationList replies={replies} />
        </AccordionContent>
      </Accordion>
    </FlexCol>
  )
}

export default RepliesAccordion
